import request from '@/utils/request'

// 增加分类
export function fileCateAdd(params) {
    return request({
		url:'/system/albums-cate/add',
		method:'post',
		data:params
	})
}
// 分类编辑
export function fileCateEdit(params) {
    return request({
        url: '/system/albums-cate/edit', 
        method:'post',
		data:params 
    });
}

// 文件分类删除
export function fileCateDelete(params) {
    return request({ 
        url: '/system/albums-cate/del', 
        method:'post',
        data:params 
    });
}

// 文件分类列表
export function fileCateList(params) {
    return request({ 
        url: '/system/albums-cate/list',
        method:'post',
        data:params, 
    });
}

//=============================================
// 文件列表
export function fileList(params) {
    return request({ 
        url: '/system/albums/pagelist',
        method:'post', 
        data:params,
    })
}

// 文件删除
export function fileDelete(params) {
    return request({ 
        url: '/system/albums/delete',
        method:'post', 
        data:params 
    })
}

// 文件移动
export function fileMove(params) {
    return request({ 
        url: '/system/albums/move',
        method:'post', 
        data:params  
    })
}

// 文件重命名
export function fileRename(params) {
    return request({ 
        url: '/system/albums/rename',
        method:'post',
        data:params 
    })
}

// 文件上传
const fileUploadPath = process.env.VUE_APP_BASE_API + 'system/albums/upload'
export { fileUploadPath }
